import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Tooltip,
  Box,
  Typography,
  makeStyles,
} from '@material-ui/core'

import ConfidenceBadge from './ConfidenceBadge'

const useStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: '#F6F6F6',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
    borderRadius: '16px',
    padding: 0,
    maxWidth: '400px',
    border: '2px solid #375EA8',
  },
  arrow: {
    color: '#375EA8',
    '&::before': {
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
    },
  },
  tooltipContent: {
    padding: theme.spacing(2),
  },
  headerText: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '18px',
    color: '#375EA8',
    marginBottom: theme.spacing(0.5),
  },
  referenceText: {
    fontFamily: 'Montserrat',
    fontSize: '12px',
    lineHeight: '18px',
    color: '#375EA8',
    fontWeight: 400,
    marginBottom: theme.spacing(2),
  },
  imageContainer: {
    width: '100%',
    borderRadius: '4px',
    overflow: 'hidden',
    border: '1px solid #E5E7EB',
    backgroundColor: '#F9FAFB',
  },
  extractedImage: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
}))

const ConfidenceTooltip = ({
  confidence,
  text,
  imageUrl,
  headerText = 'Referência da informação do contrato:',
}) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const hmlUrl = 'https://pottencial-ai-generative-contract-hml.s3.amazonaws.com'
  const prdUrl = 'https://pottencial-ai-generative-contract-prd.s3.amazonaws.com'

  const relativeImageUrl = imageUrl ? imageUrl
    .replace(hmlUrl, process.env.REACT_APP_BFF_URL)
    .replace(prdUrl, process.env.REACT_APP_BFF_URL) : ''

  const handleTooltipOpen = () => {
    setOpen(true)
  }

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const tooltipContent = (
    <Box className={classes.tooltipContent}>
      <Typography className={classes.headerText}>
        {headerText}
      </Typography>
      <Typography className={classes.referenceText}>
        {text}
      </Typography>
      {imageUrl && (
        <Box className={classes.imageContainer}>
          <img
            src={relativeImageUrl}
            alt="Document reference"
            className={classes.extractedImage}
          />
        </Box>
      )}
    </Box>
  )

  return (
    <Tooltip
      title={tooltipContent}
      open={open}
      onClose={handleTooltipClose}
      onOpen={handleTooltipOpen}
      placement="top"
      arrow
      classes={{
        tooltip: classes.tooltip,
        arrow: classes.arrow,
      }}
      interactive
      enterDelay={200}
      leaveDelay={200}
    >
      <span
        onMouseEnter={handleTooltipOpen}
        onMouseLeave={handleTooltipClose}
      >
        <ConfidenceBadge
          confidence={confidence}
        />
      </span>
    </Tooltip>
  )
}

ConfidenceTooltip.propTypes = {
  confidence: PropTypes.number,
  text: PropTypes.string,
  imageUrl: PropTypes.string,
  headerText: PropTypes.string,
}

ConfidenceTooltip.defaultProps = {
  confidence: 0,
  text: '',
  imageUrl: '',
  headerText: 'Referência da informação do contrato:',
}

export default ConfidenceTooltip
